import React from 'react';
import Home from './components/home/home';
import {Container} from 'react-materialize';


import Riscos from './components/riscos/riscos';


import RiscoFisico from './components/tipos_riscos/risco_fisico';
import RiscoQuimico from './components/tipos_riscos/risco_quimico';
import RiscoBiologico from './components/tipos_riscos/risco_biologico';
import RiscoErgonomico from './components/tipos_riscos/risco_ergonomico';
import Acidente from './components/tipos_riscos/acidente';



import Epi from './components/epi_epc/epi';
import Epc from './components/epi_epc/epc'

import Sobre from './components/sobre/sobre';
import Contato from './components/contato/contato';


import What_if from './components/ferramentas/what_if';
import What_if_do from './components/ferramentas/what_if_do';
import Five_whys from './components/ferramentas/five_whys';
import Five_whys_do from './components/ferramentas/five_whys_do';

import ChecklistGeral from './components/checklist/checklist_geral';

import ChecklistTrabalhadores from './components/checklist/checklist_trabalhadores';
import ChecklistMergulho from './components/checklist/checklist_mergulho';
import ChecklistEletrico from './components/checklist/checklist_eletrico';
import ChecklistMulher from './components/checklist/checklist_mulher';
import ChecklistProtecao from './components/checklist/checklist_protecao';
import ChecklistQuedas from './components/checklist/checklist_quedas';
import ChecklistQuimicos from './components/checklist/checklist_quimicos';
import ChecklistMaquinas from './components/checklist/checklist_maquinas';


import Gerenciamento from './components/local_trabalho/gerenciamento';
import Representation from './components/local_trabalho/representation';

import Quiz from './components/quiz/quiz';

import Videos from './components/videos/videos';

import COVID from './components/covid/covid';
import What_is_sars from './components/covid/what_is_sars';
import Symptoms from './components/covid/symptoms';
import Transmission from './components/covid/trasmission';
import Protection from './components/covid/protection';
import Hierarchy_Protection from './components/covid/hierarchy_protection';
import Workplace_Protection from './components/covid/workplace_protection';
import Yourself_Protection from './components/covid/yourself_protection';
import Masks from './components/covid/masks';
import Which_mask from './components/covid/which_mask';
import Non_sururgical_mask from './components/covid/non_sururgical_mask';
import How_to_use_it from './components/covid/how_to_use_it';
import Care_mask from './components/covid/care_mask';
import Fabric_mask from './components/covid/fabric_mask';
import Mask_disposal from './components/covid/mask_disposal';
import Other_Protection from './components/covid/other_protection';

import {Switch, Route} from 'react-router-dom';


const Main = () => (
  <main>
      <Container>
          <Switch>
              <Route exact path='/' component={Home}/>
              <Route path ='/riscos' component={Riscos}/>


              <Route path ='/risco_fisico' component={RiscoFisico}/>
              <Route path ='/risco_biologico' component={RiscoBiologico}/>
              <Route path ='/risco_quimico' component={RiscoQuimico}/>
              <Route path = '/risco_ergonomico' component={RiscoErgonomico}/>
              <Route path = '/acidente' component={Acidente}/>



              <Route path= '/epi' component={Epi}/>
              <Route path= '/epc' component={Epc}/>

              <Route path= '/sobre' component={Sobre}/>
              <Route path= '/contato' component={Contato}/>


              <Route path= '/what_if' component={What_if}/>
              <Route path= '/what_if_do' component={What_if_do}/>
              <Route path= '/five_whys' component={Five_whys}/>

              <Route path= '/five_whys_do' component={Five_whys_do}/>

              <Route path= '/checklist_geral' component={ChecklistGeral}/>

              <Route path= '/checklist_trabalhadores' component={ChecklistTrabalhadores}/>
              <Route path= '/checklist_mergulho' component={ChecklistMergulho}/>
              <Route path= '/checklist_protecao' component={ChecklistProtecao}/>
              <Route path= '/checklist_quedas' component={ChecklistQuedas}/>
              <Route path= '/checklist_quimicos' component={ChecklistQuimicos}/>
              <Route path= '/checklist_mulher' component={ChecklistMulher}/>
              <Route path= '/checklist_eletrico' component={ChecklistEletrico}/>
              <Route path= '/checklist_maquinas' component={ChecklistMaquinas}/>

              <Route path= '/quiz' component={Quiz}/>

              <Route path= '/videos' component={Videos}/>

              <Route path= '/gerenciamento' component={Gerenciamento}/>
              <Route path= '/representation' component={Representation}/>

              <Route path= '/covid' component={COVID}/>
              <Route path= '/what_is_sars' component={What_is_sars}/>
              <Route path= '/symptoms' component={Symptoms}/>
              <Route path='/transmission' component={Transmission}/>
              <Route path='/protection' component={Protection}/>
              <Route path='/hierarchy_protection' component={Hierarchy_Protection}/>
              <Route path='/workplace_protection' component={Workplace_Protection}/>
              <Route path='/yourself_protection' component={Yourself_Protection}/>
              <Route path='/masks' component={Masks}/>
              <Route path='/which_mask' component={Which_mask}/>
              <Route path='/non_sururgical_mask' component={Non_sururgical_mask}/>
              <Route path='/how_to_use_it' component={How_to_use_it}/>
              <Route path='/care_mask' component={Care_mask}/>
              <Route path='/fabric_mask' component={Fabric_mask}/>
              <Route path='/mask_disposal' component={Mask_disposal}/>
              <Route path='/other_protection' component={Other_Protection}/>

          </Switch>

         <Home/>
      </Container>

  </main>

);

export default Main;